// Set webpack public path at runtime for iframe/CDN environments
declare let __webpack_public_path__: string;

export function setPublicPath(): void {
  // Try to detect the current script's base URL
  try {
    // Method 1: Use document.currentScript if available
    const currentScript = document.currentScript as HTMLScriptElement;
    if (currentScript && currentScript.src) {
      const scriptUrl = new URL(currentScript.src);
      const basePath = scriptUrl.origin + scriptUrl.pathname.replace(/\/[^\/]*$/, '/');
      __webpack_public_path__ = basePath;
      return;
    }

    // Method 2: Find the script tag that loaded this library
    const scripts = document.getElementsByTagName('script');
    for (let i = scripts.length - 1; i >= 0; i--) {
      const script = scripts[i];
      if (script.src && (script.src.includes('agentai-web-sdk') || script.src.includes('kore'))) {
        const scriptUrl = new URL(script.src);
        const basePath = scriptUrl.origin + scriptUrl.pathname.replace(/\/[^\/]*$/, '/');
        __webpack_public_path__ = basePath;
        return;
      }
    }

    // Method 3: Use the iframe's location if we're in an iframe
    if (window.self !== window.top) {
      const currentLocation = window.location;
      __webpack_public_path__ = currentLocation.origin + currentLocation.pathname.replace(/\/[^\/]*$/, '/');
      return;
    }

    // Fallback: Use relative path
    __webpack_public_path__ = './';
  } catch (error) {
    console.warn('Failed to detect publicPath, using relative path:', error);
    __webpack_public_path__ = './';
  }
}

// Auto-initialize when module is loaded
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  setPublicPath();
} 